import { Component, OnInit } from '@angular/core';
import { RedirectRequest } from '@azure/msal-browser';
import { UserService } from '@app/services/user.service';

@Component({
  selector: 'login',
  template: ''
})
export class LoginComponent implements OnInit {
  constructor(private userService: UserService) { }

  ngOnInit(): void {
    // Always initiate the login redirect and ask MSAL to return to '/' after successful login.
    const redirectReq: RedirectRequest = { redirectStartPage: '/' } as RedirectRequest;
    this.userService.loginRedirect(redirectReq);
  }

}
